import React from "react";
import Select, { components } from "react-select";
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = ({ children, ...props }) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(children, (child) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

const SelectComponent = (props) => {
  const customStyles = {
    menu: (base) => ({ ...base, zIndex: 9999 }),
    container: (provided, state) => ({
      ...provided,
      marginTop: 50,
    }),
    valueContainer: (provided, state) => ({
      ...provided,
      overflow: "visible",
    }),
    placeholder: (provided, state) => ({
      ...provided,
      position: "absolute",
      top: state.hasValue || state.selectProps.inputValue ? "-13px" : "15%",
      backgroundColor:
        state.hasValue || state.selectProps.inputValue
          ? "white"
          : "transparent",
      transition: "top 0.1s, font-size 0.1s",
      fontSize: (state.hasValue || state.selectProps.inputValue) && 11,
      paddingRight:
        state.hasValue || state.selectProps.inputValue ? "4px" : "0px",
      paddingLeft:
        state.hasValue || state.selectProps.inputValue ? "4px" : "0px",
    }),
  };

  return (
    <Select
      classNamePrefix="select"
      components={{
        ValueContainer: CustomValueContainer,
      }}
      {...props}
      styles={customStyles}
      value={props?.value || props?.field?.value || ""}
      onChange={props?.onChange || props?.field?.onChange}
      closeMenuOnSelect={!props.isMulti}
    />
  );
};

export default SelectComponent;
